export default __webpack_public_path__ + "static/media/accounts1.fe383424.svg";